import { paymentsApi } from '.';

export interface TransactionFetchData {
  client: string,
  amount: number,
  currency: string,
  email: string,
  firstName: string,
  lastName: string,
  address1: string,
  address2: string | null,
  address3: string | null,
  postcode: string,
  town: string,
  country: string,
  successUrl: string,
  failureUrl: string,
  transSourceUrl?: string,
}

export interface TransactionFetchResponse {
  data: TransactionFetchData,
  message: string,
}

export interface TransactionFetchRequest {
  transactionId: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    fetchTransaction: builder.query<TransactionFetchResponse, TransactionFetchRequest>({
      query: body => ({
        url: 'payment/fetch',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useLazyFetchTransactionQuery } = extendedPaymentsApi;
